/**
 * Cross-tab serialization for /auth/refresh calls.
 *
 * The API's refresh-token rotation revokes the old token atomically and fires a
 * "theft detected" response if a previously-rotated token is presented again
 * (api/src/modules/auth/auth.service.ts refreshTokens). Two tabs racing on
 * boot-time refresh would both send the original cookie value, the loser would
 * match a revoked hash, and the API would revoke the entire token family.
 *
 * `navigator.locks.request('la-auth-refresh', ...)` serializes the callback
 * across same-origin tabs, so by the time Tab B runs, Tab A has rotated the
 * cookie and B presents the fresh value. Browsers without the Web Locks API
 * fall back to running immediately (single-tab dedupe in apiFetch still applies).
 */
export async function withRefreshLock<T>(fn: () => Promise<T>): Promise<T> {
  if (typeof navigator !== 'undefined' && 'locks' in navigator && navigator.locks) {
    return await navigator.locks.request('la-auth-refresh', { mode: 'exclusive' }, async () => {
      return await fn();
    });
  }
  return await fn();
}
